import "./share.scss";
import Image from "../../assets/Img-Video.png";
import { useContext, useState } from "react";
import { AuthContext } from "../../context/authContext";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { makeRequest } from "../../axios";
import AWS from "aws-sdk";
import { notification } from "antd";
import imageCompression from "browser-image-compression";

const awsRegion = process.env.REACT_APP_AWS_REGION;
const awsSecretAccessKey = process.env.REACT_APP_AWS_SECRET_ACCESS_KEY;
const awsAccessKeyId = process.env.REACT_APP_AWS_ACCESS_KEY_ID;

const Share = () => {
  const [file, setFile] = useState(null);
  const [desc, setDesc] = useState("");
  const [isUploading, setIsUploading] = useState(false); // Initialize uploading state
  const [inputNameError, setInputNameError] = useState("");

  AWS.config.update({
    accessKeyId: awsAccessKeyId,
    secretAccessKey: awsSecretAccessKey,
    region: awsRegion,
  });
 
  const { currentUser } = useContext(AuthContext);
  const queryClient = useQueryClient();

  const mutation = useMutation(
    (newPost) => {
      console.log("this is from method", newPost.get("postImage"), typeof newPost);
      return makeRequest.post(
        `/users/posts/addPost/${currentUser.id}`,
        newPost,
        {
          headers: {
            "Content-Type": "multipart/form-data",  // Manually setting the Content-Type header
          },
        }
      );
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["posts"]);
        queryClient.invalidateQueries(["lastestActivities"]);
        notification.success({
          message: "Post uploaded successfully",
          description: "Your post has been shared with everyone.",
        });
      },
      onSettled: () => {
        setIsUploading(false);
      },
    }
  );


  const handleInput = (e) => {
    setDesc(e.target.value);
    if (e.target.value.length > 0) {
      setInputNameError("");
    }
  };



    const handleClick = async () => {
    if (!desc && !file) {
      notification.error({
        message: "No Image or No Description",
        description: "You have to add an image or a description.",
      });
      return;
    }

    setIsUploading(true);

    let fileToUpload = file;

    if (file) {
      try {
        if (file.type.startsWith("image")) {
          // Compress image to be less than 150KB
          const imageOptions = {
            maxSizeMB: 0.1, // 150KB
            maxWidthOrHeight: 1920,
            useWebWorker: true,
          };
          const compressedBlob = await imageCompression(file, imageOptions);

          // Convert the compressed Blob back to a File
          fileToUpload = new File([compressedBlob], file.name, {
            type: compressedBlob.type,
            lastModified: file.lastModified,
          });
        } else if (file.type.includes("video")) {
          // Check if the video size exceeds 10MB
          const maxVideoSizeMB = 10;
          const videoSizeMB = file.size / 1024 / 1024;
          if (videoSizeMB > maxVideoSizeMB) {
            notification.error({
              message: 'Video Too Large',
              description: `The video size is ${videoSizeMB.toFixed(2)} MB, which exceeds the 10MB limit.`,
            });
            setIsUploading(false);
            return;
          }

          fileToUpload = file;
        }

        // Upload the file
        const formData = new FormData();
        formData.append("postName", desc);
        formData.append("postImage", fileToUpload);
        formData.append("postType", file.type);
        console.log("this is formdata", formData.get("postName"))

        mutation.mutate(formData);
      } catch (error) {
        console.log("Error during compression or upload:", error);
      } finally {
        setFile(null);
        setDesc("");
        setIsUploading(false);
      }
    } else {
      if (desc) {
        try {
          const formData = new FormData();
          formData.append("postName", desc);

          mutation.mutate(formData);

        } catch (error) {
          console.log("Error during compression or upload:", error);
        } finally {
          setFile(null);
          setDesc("");
          setIsUploading(false);
        }
      }
    }
  };

  return (
    <div className="share">
      <div className="container">
        <div className="top">
          <div className="left">
            <img src={currentUser.profilePic} alt="" />
            <textarea
              rows={"1"}
              type="text"
              placeholder={`share yours thoughts...`}
              onChange={handleInput}
              value={desc}
              disabled={isUploading}
              style={{ backgroundColor: "#f3f3f3", borderRadius: "15px" }}
            />
          </div>
          <div className="right">
            {file && file.type.startsWith("image/") && (
              <img
                className="file"
                alt=""
                src={URL.createObjectURL(file)}
                style={{ borderRadius: "20px" }}
              />
            )}
            {file && file.type.startsWith("video/") && (
              <video className="file" controls>
                <source src={URL.createObjectURL(file)} type={file.type} />
                Your browser does not support the video tag.
              </video>
            )}
            {/* Message when no file is selected */}
          </div>
        </div>
        {inputNameError && <span className="inputError">{inputNameError}</span>}
        <hr />
        <div className="bottom">
          <div className="left">
            <label htmlFor="file">
              <div className="item">
              <img src={Image} alt="" width={"40px"} height={"50px"} />
              <span>Add Image/Video</span>
              </div>              
            </label>
            <input
              type="file"
              id="file"
              accept="image/*,video/*"
              style={{ display: "none" }}
              onChange={(e) => setFile(e.target.files[0])}
              disabled={isUploading} // Disable file input during upload
            />
            {/* <label htmlFor="file">
              <div className="item">
                <img src={Image} alt="" width={"40px"} height={"50px"} />
                <span>Add Activites</span>
              </div>
            </label> */}
          </div>
          <div className="right">
            <button onClick={handleClick} disabled={isUploading}>
              {isUploading ? "Sharing..." : "Share"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Share;
